/**
 * GroupBadge — renders a small chip for a resident group tag.
 * @param {{ name: string }} props
 */
const GroupBadge = ({ name }) => {
  return (
    <span className="rp-group-badge">
      {name}
    </span>
  );
};

export default GroupBadge;
